<template>
    <div class="header">
      <img src="@/assets/images/logo_small.png" width="105px" @click="register">
      <!-- **************header***************** -->
      <div class="title">
        <span><router-link class="home" to="/">Genome-wide summary statistics</router-link></span>
      </div>
    </div>
</template>
<script>
export default {
  methods: {
    register () {
      // 编程式导航
      this.$router.push({ name: 'home' }, () => {}, () => {})
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  border-bottom: 1px solid #140f0f21;
  display: flex;
  padding: 5px 20px;
  background-color:#F5F5F5;
  height: 49px;
  .title {
    margin-left: 20px;
    align-items: center;
    align-self: center;
    font-size: 26px;
    font-weight: 600;
    color: #0B4174;
  }
}
.home{
  text-decoration: none;
}
img{
  mix-blend-mode: multiply;
  padding: 5px 5px 5px 20px;
  width: 227px;
}
img:hover{
  cursor: pointer;
}
span a{
  font-size: 24px;
  font-weight: 600;
  color: #013B96;
}
</style>
